// Recovered compiled webpack factory 22311. Edit this function expression; run npm run build.
(e) => {
  e.exports = {
    style: { fontFamily: "'GeistSans', 'GeistSans Fallback'" },
    className: "__className_8adcd2",
    variable: "__variable_8adcd2",
  };
}
